import { StyleSheet } from 'react-native';
import {
  fontFamilySemiBold,
  fontSizeSmall,
  lightPurple,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 30,
    marginTop: 20,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  switchContainer: {
    flex: 1,
    flexDirection: 'row',
  },
  text: {
    fontSize: fontSizeSmall,
  },
  linkStyle: {
    color: lightPurple,
    fontFamily: fontFamilySemiBold,
  },
  textStyle: {
    marginLeft: 20,
  },
});
